import {useState} from "react";
import {Tooltip} from "antd";
import useDataTableMedia from "./DataTable";
import {useAppSelector} from "../../../../Redux/hooks";
import {setOpenModalDel} from "../../store/rmboxActions";
import {useDispatch} from "react-redux";
import {DataRmbox} from "../../utils/Data";
import {useTranslation} from "react-i18next";
import Hooks from "../../utils/hooks";
import '../../rmbox.scss'
import { Button } from "@empreinte/components.button";
import DeleteIcon from '@mui/icons-material/Delete';
import { ModalConfirm } from "@empreinte/components.modal-confirm";
import { SearchBar } from "@empreinte/components.search-bar";


const RmboxTable = () =>{

    const dispatch = useDispatch()
    const {t} = useTranslation();
    const {columns} = DataRmbox()
    const data = useAppSelector((state) => state.RmboxReducer.dataRmbox)
    const {getAllData,handleSearchRow, Deletemultipleselecteditem} = Hooks()
    const [openModal,setOpenModal] = useState(false);
    const checkedCase = useAppSelector((state)=>state.RmboxReducer.selectedCase)
    const openDel = useAppSelector((state)=>state.RmboxReducer.showDeleteSpace);
    const isSuperAdmin = useAppSelector((state: any) => state.ReducerUserData.isSuperAdmin)
    const { configuration_rmbox_module } = useAppSelector((state: any) => state.ReducerUserData.modules)
    const numberOfselectedRows = checkedCase.length
    const [searchText,setSearchText]=useState('')
    const [currentPage,setCurrentPage]=useState(1);
    const [pageSize]=useState(10)
    // fontion pour afficher le tableau de n'interface
    const {
        DataTable,
    } = useDataTableMedia({
        columns: columns,
        dataSource: data,
        updateEntityPath: 'update-product',
    });


    const onSearch = (e:any) => {
        setSearchText(e.target.value);
        handleSearchRow(e.target.value)
        getAllData(currentPage,pageSize,e.target.value)
        setCurrentPage(1)
    }

    return(
        <div >

            <div className="Filter">

                {!openDel
                        ?
                        null
                        :
                        <div className="delete_number">
                            <Tooltip title={t('Rmbox.delete')}>
                                <Button style={{border: "1px solid rgba(0 , 0 , 0 , 0.15)"}} 
                                color="inherit" 
                                startIcon={<DeleteIcon/>} 
                                onClick={() =>{
                                    dispatch(setOpenModalDel(true));
                                    setOpenModal(true)
                                }
                                
                                }/>
                            </Tooltip>
                            <p><span>{numberOfselectedRows || ""}</span> <span id={"text_selection"}>{t('Rmbox.selectedItem')}</span></p>
                        </div>
                }
                 {openModal && (    
                    <ModalConfirm
                        open={openModal}
                        onClose={()=>setOpenModal(false)}
                        title={t('Zone.Delete')}
                        content={numberOfselectedRows === 1 ?t('Zone.DeleteConfirmationOneDelete'):t('Zone.DeleteConfirmationMultiDelete')}
                        fullWidth={true}
                        CancelBtnName={t('boitier.No')}
                        ConfirmBtnName={t('boitier.Yes')}
                        onCancel={()=>setOpenModal(false)}
                        onConfirm={() => 
                        {
                            Deletemultipleselecteditem()
                            dispatch(setOpenModalDel(false))
                            setOpenModal(false)
                        }}
                    />)}
                <div className={"div_rect"}>
                    <div className="rect_filter">

                    <SearchBar name={"search"}
                       className="rect_filter_search"
                           placeholder={t('Rmbox.search')}
                            setSearchText={onSearch}
                            value={searchText}
                           />

                    </div>
                </div>
                
            </div>{/*./Filter*/}

            {(configuration_rmbox_module?.configuration_rmbox_list_dtable_action?.authorized || isSuperAdmin) &&
            <div has-permission="configuration_rmbox_list_dtable_action" className={"dataTable"}>
                <DataTable/>
            </div>}
            {/*./dataTable*/}


        </div>
    )
}

export default RmboxTable
